/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import Api from "../../api";

import audienceSlice from "../../store/entities/audience/audience-slice.reducer";
import { formatDate, formatNumber } from "../../helpers/formatter";

import {
  Button,
  ModalView,
  Popover,
  PopoverBody,
  PopoverHeader,
  Tooltip
} from "../../components/simple";
import { audiencePopoverOptions } from "../../helpers/popoverOptions";
import OptionTooltip from "../../components/complex/Tooltips/Options";
import SVG from "../../components/SVG";

import Modal from "../../components/simple/Modal";
import LimitWarning from "./PushModal/LimitWarning";
import PushModal from "./PushModal";
import { ModalSelectClientBeforePush } from "../../components/forms/ModalSelectClientBeforePush";

function AudienceRow({
  audience,
  onRemove,
  onEdit,
  onEditBuilder,
  onClick,
  onRestore,
  canEdit,
  canRemove,
  user,
  companyPlan,
  // clientId = "",
  clients,
  isSelectClientModalHasOpened,
  setIsSelectClientModalHasOpened,
  isTrashRow,
  currentSubscription
}) {
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    actions: { showShareAudienceModal }
  } = audienceSlice;

  const [audiencePopperId, setAudiencePopper] = useState(null);
  // const [tooltipForId, setIdTooltip] = useState(null);
  const [tooltipForCountry, setCountryTooltip] = useState(null);
  const [optionsPopper, setOptionsPopper] = useState(null);

  const [adformToken, setAdformToken] = useState("");
  const [snapchatToken, setSnapchatToken] = useState("");

  const [isShowPushModal, setIsShowPushModal] = useState(false);
  const [isLimitWarningModalOpen, setIsLimitWarningModalOpen] = useState(false);

  const [isShowRemoveModal, setIsShowRemoveModal] = useState(false);

  const [isSelectClientModalOpen, setIsSelectClientModalOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  useEffect(() => {
    const params = queryString.parse(location.search);

    if (params.adformToken) {
      setAdformToken(params.adformToken);
      // setSelectedClient(clientId);
    }

    if (params.snapchatToken) {
      setSnapchatToken(params.snapchatToken);
      // setSelectedClient(clientId);
    }
    // }, [location.search, clientId]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    if (!selectedClient) return;

    if (!companyPlan?.limitedFunctionality) setIsShowPushModal(true);
    else if (companyPlan?.limitedFunctionality)
      setIsLimitWarningModalOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClient, companyPlan?.limitedFunctionality]);

  const toggleAudience = (evt, id = null) => {
    evt.stopPropagation();
    evt.preventDefault();
    // setIdTooltip(null);
    setCountryTooltip(null);
    setOptionsPopper(null);
    setAudiencePopper(id && audiencePopperId !== id ? id : null);
  };

  const openReport = (evt, id) => {
    evt.stopPropagation();

    if (isShowPushModal || isLimitWarningModalOpen) return;

    onClick(id);
  };
  const toggleOptions = (evt, id = null) => {
    evt.stopPropagation();
    evt.preventDefault();
    // setIdTooltip(null);
    setCountryTooltip(null);
    setAudiencePopper(null);
    setOptionsPopper(id && optionsPopper !== id ? id : null);
  };

  const toggleCountry = (evt, id = null) => {
    evt.stopPropagation();
    evt.preventDefault();
    // setIdTooltip(null);
    setOptionsPopper(null);
    setAudiencePopper(null);
    setCountryTooltip(id && tooltipForCountry !== id ? id : null);
  };

  // const toggleId = (evt, id = null) => {
  //   evt.stopPropagation();
  //   evt.preventDefault();
  //   setCountryTooltip(null);
  //   setOptionsPopper(null);
  //   setAudiencePopper(null);
  //   setIdTooltip(id && tooltipForId !== id ? id : null);
  // };

  const onSelectClient = async (data = {}) => {
    const { clientsId = null } = data;

    setSelectedClient(clientsId);
    setIsSelectClientModalOpen(false);
    setIsSelectClientModalHasOpened(false);
    setIsShowPushModal(true);
  };

  const audienceTarget = `audience-popper-${audience.id}`;
  const optionTarget = `audience-options-${audience.id}`;
  const tooltipOptions = {
    placement: "top",
    isOpen: optionsPopper === audience.id,
    target: optionTarget,
    toggle: evt => toggleOptions(evt),
    trigger: "legacy",
    fade: true,
    flip: false
  };

  const audienceActions = [];
  const [audienceActionsLight, setAudienceActionsLight] = useState([]);

  useEffect(() => {
    if (currentSubscription === "Light") {
      const arr = [];
      arr.push({
        label: "Push to platforms",
        callback: e => {
          e.stopPropagation();
          setOptionsPopper(null);
          setIsShowPushModal(true);
        }
      });
      if (!audience.isPreset) {
        arr.push({
          label: "Share with email",
          callback: evt => {
            evt.stopPropagation();
            dispatch(showShareAudienceModal(audience?.id));
            setOptionsPopper(null);
          }
        });
      }
      setAudienceActionsLight(arr);
    }
  }, [
    dispatch,
    showShareAudienceModal,
    audience,
    currentSubscription,
    setAudienceActionsLight
  ]);
  if (isTrashRow) {
    audienceActions.push({
      label: "Restore",
      callback: evt => {
        evt.stopPropagation();
        setOptionsPopper(null);
        onRestore();
      }
    });

    if (canRemove) {
      audienceActions.push({
        label: "Remove",
        className: "danger",
        callback: evt => {
          evt.stopPropagation();
          // setIsShowRemoveModal(true);
          onRemove();
          setOptionsPopper(null);
        }
      });
    }
  } else {
    if (audience.audienceVariables) {
      audienceActions.push({
        label: "Edit Name & Client",
        callback: evt => {
          evt.stopPropagation();
          setOptionsPopper(null);
          onEdit();
        }
      });
    } else {
      audienceActions.push({
        label: "Activate",
        callback: evt => {
          evt.stopPropagation();
          setOptionsPopper(null);

          if (!isSelectClientModalHasOpened)
            setIsSelectClientModalHasOpened(true);
          setIsSelectClientModalOpen(true);
          // if (!companyPlan.limitedFunctionality) setIsShowPushModal(true);
          // else if (companyPlan.limitedFunctionality)
          //   setIsLimitWarningModalOpen(true);
        }
      });
    }

    // audienceActions.push({
    //   label: "Push to platforms",
    //   callback: e => {
    //     e.stopPropagation();
    //     setOptionsPopper(null);
    //     setIsShowPushModal(true);
    //   }
    // });

    if (canEdit) {
      audienceActions.push({
        label: "Edit Audience",
        callback: evt => {
          evt.stopPropagation();
          setOptionsPopper(null);
          onEditBuilder();
        }
      });
    }

    if (!audience.isPreset) {
      audienceActions.push({
        label: "Share with email",
        callback: evt => {
          evt.stopPropagation();
          dispatch(showShareAudienceModal(audience?.id));
          setOptionsPopper(null);
        }
      });
    }

    audienceActions.push({
      label: "Duplicate",
      callback: evt => {
        evt.stopPropagation();
        Api.audience.duplicateAudience({
          data: { audienceId: audience?.id, isPreset: audience.isPreset }
        });
        setOptionsPopper(null);
      }
    });

    if (canRemove) {
      audienceActions.push({
        label: "Remove",
        className: "danger",
        callback: evt => {
          evt.stopPropagation();
          setIsShowRemoveModal(true);
          // onRemove();
          setOptionsPopper(null);
        }
      });
    }
  }

  return (
    <tr
      role="row"
      tabIndex={0}
      id={audienceTarget}
      onKeyPress={evt => openReport(evt, audience.id)}
      onClick={evt =>
        currentSubscription !== "Light"
          ? openReport(evt, audience.id)
          : onSelectClient()
      }
    >
      <td
        height="40px"
        className="name"
        style={{
          borderTopLeftRadius: "2px",
          borderBottomLeftRadius: "2px"
        }}
        // onFocus={evt => toggleAudience(evt, audience.id)}
        // onMouseEnter={evt => toggleAudience(evt, audience.id)}
        // onBlur={evt => toggleAudience(evt)}
        // onMouseLeave={evt => toggleAudience(evt)}
      >
        {/* <b className="d-block">{audience.name}</b> */}
        {audience.name}
      </td>
      {/* <td */}
      {/*  className="id" */}
      {/*  id={`id-${audience.id}`} */}
      {/*  onFocus={evt => toggleId(evt, audience.id)} */}
      {/*  onMouseEnter={evt => toggleId(evt, audience.id)} */}
      {/*  onBlur={evt => toggleId(evt)} */}
      {/*  onMouseLeave={evt => toggleId(evt)} */}
      {/* > */}
      {/*  <Tooltip */}
      {/*    autohide */}
      {/*    hideArrow */}
      {/*    placement="top" */}
      {/*    isOpen={audience.id === tooltipForId} */}
      {/*    toggle={evt => toggleId(evt)} */}
      {/*    target={`id-${audience.id}`} */}
      {/*  > */}
      {/*    {audience.internalId} */}
      {/*  </Tooltip> */}
      {/*  {audience.internalId} */}
      {/* </td> */}
      <td height="40px" className="reach">
        {typeof audience.populationLl === "number" ? (
          <>
            {/* <b> */}
            {/*  {audience.populationLl && formatNumber(audience.populationLl)} */}
            {/* </b> */}
            {/* /!*persons*!/ */}
            {audience.populationLl
              ? formatNumber(audience.populationLl)
              : audience.populationLl}
          </>
        ) : (
          0
        )}
      </td>
      <td height="40px" className="type">
        {audience.audienceType ? audience.audienceType : "Pre-build"}
      </td>
      <td
        height="40px"
        className="country"
        onFocus={evt =>
          toggleCountry(evt, `${audience.id}-${audience.country.name}`)
        }
        onMouseEnter={evt =>
          toggleCountry(evt, `${audience.id}-${audience.country.name}`)
        }
        onBlur={evt => toggleCountry(evt)}
        onMouseLeave={evt => toggleCountry(evt)}
        id={`country-${audience.id}-${audience.country.name.replace(
          /\s+/m,
          "_"
        )}`}
      >
        <div className="flex">
          <Tooltip
            autohide
            hideArrow
            placement="bottom-start"
            isOpen={
              `${audience.id}-${audience.country.name}` === tooltipForCountry
            }
            toggle={evt =>
              toggleCountry(evt, `${audience.id}-${audience.country.name}`)
            }
            target={`country-${audience.id}-${audience.country.name.replace(
              /\s+/m,
              "_"
            )}`}
          >
            {audience.country.name}
          </Tooltip>
          <span
            className={`flag-icon flag-icon-${audience.country.code.toLowerCase()}`}
          ></span>
        </div>
      </td>
      <td height="40px" className="created-at">
        {audience.createdAt ? formatDate(audience.createdAt) : ""}
      </td>
      {/* <td className="quality-indicator"> */}
      {/*  <div */}
      {/*    className={ */}
      {/*      audience.qualityIndicator && audience.qualityIndicator.toLowerCase() */}
      {/*    } */}
      {/*  /> */}
      {/* </td> */}
      {currentSubscription !== "Light" ? (
        <td height="40px" className="options">
          <Button
            type="button"
            onClick={evt => {
              evt.stopPropagation();
              evt.preventDefault();
              toggleOptions(evt, audience.id);
            }}
            id={optionTarget}
          >
            <SVG.Dots className="dots" />
          </Button>
          <OptionTooltip
            tooltipOptions={tooltipOptions}
            actions={audienceActions}
          />
        </td>
      ) : (
        <td
          height="40px"
          className="options"
          style={{
            borderTopRightRadius: "2px",
            borderBottomRightRadius: "2px"
          }}
        >
          <Button
            type="button"
            onClick={evt => {
              evt.stopPropagation();
              evt.preventDefault();
              toggleOptions(evt, audience.id);
            }}
            id={optionTarget}
          >
            <SVG.Dots className="dots" />
          </Button>
          <OptionTooltip
            tooltipOptions={tooltipOptions}
            actions={audienceActionsLight}
          />
        </td>
      )}
      <Popover
        {...audiencePopoverOptions}
        isOpen={audiencePopperId === audience.id}
        target={audienceTarget}
        toggle={evt => toggleAudience(evt)}
      >
        <PopoverHeader>{audience.name}</PopoverHeader>
        <PopoverBody>
          <div className="audience-popper-container">
            <h5>Description:</h5>
            <p className="description">{audience.description}</p>
          </div>
          <div className="audience-popper-container">
            <h5>Created by:</h5>
            <div className="audience-creator">
              <SVG.Client className="user-icon" />
              <span>{audience.createdBy || ""}</span>
            </div>
          </div>
        </PopoverBody>
      </Popover>
      <PushModal
        isOpen={isShowPushModal}
        onClose={() => {
          setIsShowPushModal(false);
        }}
        audience={audience}
        adformToken={adformToken}
        snapchatToken={snapchatToken}
        user={user}
        clientId={selectedClient}
        currentSubscription={currentSubscription}
      />
      {isLimitWarningModalOpen && (
        <Modal
          isOpen={isLimitWarningModalOpen}
          handleClose={() => setIsLimitWarningModalOpen(false)}
        >
          <LimitWarning
            onShow
            onPushAnyway={() => {
              setIsLimitWarningModalOpen(false);
              setIsShowPushModal(true);
            }}
          />
        </Modal>
      )}

      <ModalView
        isOpen={isShowRemoveModal}
        toggle={() => {
          setIsShowRemoveModal(prevState => !prevState);
        }}
        changeModalState={() => {
          setIsShowRemoveModal(prevState => !prevState);
        }}
        handleClose={() => {
          setIsShowRemoveModal(false);
        }}
      >
        <h2 className="title text-center mb-3">Delete audience </h2>
        <p className="description mb-4" style={{ textAlign: "center" }}>
          Are you sure you want to delete the audience?
        </p>
        <div className="buttons-container">
          <Button
            onClick={onRemove}
            className="button button-danger justify-content-center ml-auto mr-auto mt-4"
          >
            Move to trash
          </Button>
        </div>
      </ModalView>

      <ModalSelectClientBeforePush
        modalTitle="Select your client"
        data={audience}
        type="preset"
        clients={clients}
        isOpen={isSelectClientModalOpen}
        changeModalState={() => {
          setIsSelectClientModalOpen(prevState => !prevState);
          setIsSelectClientModalHasOpened(false);
        }}
        handleSubmit={onSelectClient}
      />
    </tr>
  );
}

AudienceRow.propTypes = {
  // clientId: PropTypes.string.isRequired,
  clients: PropTypes.shape({}).isRequired,
  isSelectClientModalHasOpened: PropTypes.bool.isRequired,
  setIsSelectClientModalHasOpened: PropTypes.func.isRequired,
  currentSubscription: PropTypes.string.isRequired,
  companyPlan: PropTypes.arrayOf(
    PropTypes.shape({
      limitedFunctionality: PropTypes.bool.isRequired
    })
  ).isRequired,
  user: PropTypes.shape({}).isRequired,
  onEdit: PropTypes.func.isRequired,
  onEditBuilder: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  onRemove: PropTypes.func.isRequired,
  audience: PropTypes.shape({
    audienceVariables: PropTypes.arrayOf(
      PropTypes.arrayOf(PropTypes.shape({}))
    ),
    isPreset: PropTypes.bool,
    id: PropTypes.string,
    internalId: PropTypes.number,
    status: PropTypes.string,
    description: PropTypes.string,
    name: PropTypes.string,
    createdBy: PropTypes.string,
    createdAt: PropTypes.string,
    qualityIndicator: PropTypes.string,
    populationLl: PropTypes.number,
    audienceType: PropTypes.string,
    country: PropTypes.shape({
      name: PropTypes.string,
      code: PropTypes.string
    })
  }).isRequired,
  canEdit: PropTypes.bool,
  canRemove: PropTypes.bool,
  onRestore: PropTypes.func,
  isTrashRow: PropTypes.bool
};

AudienceRow.defaultProps = {
  onClick: () => {},
  canEdit: false,
  canRemove: false,
  onRestore: () => {},
  isTrashRow: false
};

export default AudienceRow;
